<h1 class="row justify-content-center">{{'dpo.i18n.subscription.popup.title' | translate}}</h1>
<div mat-dialog-content>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <p *ngIf="data.source === 'validate'">{{'dpo.i18n.message.subscription.validate' | translate}}</p>
                <p *ngIf="data.source === 'cancel'">{{'dpo.i18n.message.subscription.cancel' | translate}}</p>
            </div>
        </div>
    </div>
</div>
<div class="row justify-content-end action-button">
    <button *ngIf="data.source === 'validate'" class="btn" (click)="ok()"
        cdkFocusInitial>{{'dpo.i18n.subscription.button.ok' | translate}}</button>
    <button *ngIf="data.source === 'cancel'" class="btn" (click)="validate()"
        cdkFocusInitial>{{'dpo.i18n.subscription.button.validate' | translate}}</button>
    <button *ngIf="data.source === 'cancel'" class="btn"
        (click)="close()">{{'dpo.i18n.subscription.button.close' | translate}}</button>
</div>